import React, { useState } from 'react';
import 'date-fns';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  MenuItem,
  TextField,
} from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { VERIFICATION_METHOD } from '../../constants/identity';

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 250,
  },
  clearAll: {
    margin: `${theme.spacing(3)}px ${theme.spacing(1)}px`,
  },
}));

const types = [
  {
    value: '',
    label: 'Wszystkie',
  },
  {
    value: 'individual',
    label: 'Indywidualny',
  },
  {
    value: 'sole_proprietorship',
    label: 'JDG',
  },
  {
    value: 'company',
    label: 'Spółka lub fundacja',
  },
];

const statuses = [
  {
    value: '',
    label: 'Wszystkie',
  },
  {
    value: 'new',
    label: 'Nowe',
  },
  {
    value: 'in_progress',
    label: 'W trakcie',
  },
  {
    value: 'accepted',
    label: 'Zaakceptowane',
  },
  {
    value: 'rejected',
    label: 'Odrzucone',
  },
];

const dateInputs = [
  {
    value: 'after_date',
    label: 'Utworzone po dniu',
  },
  {
    value: 'before_date',
    label: 'Utworzone przed dniem',
  },
  {
    value: 'updated_at',
    label: 'Zaktualizowano',
  },
];

const identityVerMethodsInputs = [
  {
    value: '',
    label: 'Wszystkie',
  },
  {
    value: VERIFICATION_METHOD.BANQUP,
    label: 'BanqUp',
  },
  {
    value: VERIFICATION_METHOD.TRANSFER,
    label: 'Przelew',
  },
];

const INITIAL_STATE = {
  action_required_only: true,
  type: '',
  status: '',
  after_date: null,
  before_date: null,
  updated_at: null,
  identity_ver_method: '',
};

const withSupportOrderFilters = Component => props => {
  const classes = useStyles();

  const [filters, setFilters] = useState(INITIAL_STATE);
  const [search, setSearch] = useState('');

  const handleChange = e => {
    const {
      name,
      value,
      checked,
    } = e.target;
    setFilters(f => ({
      ...f,
      [name]: checked !== undefined ? checked : value,
    }));
  };

  const handleDateChange = (date, fieldName) => {
    if (Number.isNaN(date.getTime())) return; // w trakcie ręcznego  wpisywania
    setFilters(f => ({
      ...f,
      [fieldName]: date.toISOString(),
    }));
  };

  const handleClear = () => setFilters(INITIAL_STATE);

  const renderFilters = () => (
    <div>
      <FormGroup>
        <FormControl className={classes.formControl}>
          <FormControlLabel
            control={(
              <Checkbox
                color="primary"
                onChange={handleChange}
                name="action_required_only"
                checked={filters.action_required_only}
              />
            )}
            label="Tylko zlecenia wymagające akcji"
          />
        </FormControl>
      </FormGroup>
      <FormGroup row>
        <FormControl className={classes.formControl}>
          <TextField
            name="search"
            label="Kod"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </FormControl>
        <FormControl className={classes.formControl}>
          <TextField
            select
            name="type"
            label="Typ"
            value={filters.type}
            onChange={handleChange}
          >
            {types.map(({
              value,
              label,
            }) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </FormControl>
        <FormControl className={classes.formControl}>
          <TextField
            select
            label="Status"
            value={filters.status}
            name="status"
            onChange={handleChange}
            disabled={filters.action_required_only}
          >
            {statuses.map(({
              value,
              label,
            }) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </FormControl>
        <FormControl className={classes.formControl}>
          <TextField
            select
            label="Metoda weryfikacji"
            value={filters.identity_ver_method}
            name="identity_ver_method"
            onChange={handleChange}
          >
            {identityVerMethodsInputs.map(({
              value,
              label,
            }) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </FormControl>
      </FormGroup>
      <FormGroup row>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          {dateInputs.map(({
            value,
            label,
          }) => (
            <FormControl className={classes.formControl}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="normal"
                id="date-picker-inline"
                label={label}
                name={value}
                value={filters[value]}
                onChange={(date) => handleDateChange(date, value)}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
            </FormControl>
          ))}
        </MuiPickersUtilsProvider>
      </FormGroup>
      <Button
        className={classes.clearAll}
        variant="outlined"
        onClick={handleClear}
        disabled={Object.values(filters)
          .every(f => !f)}
      >
        Wyczyść filtry
      </Button>
    </div>
  );

  return (
    <Component {...props} filters={filters} search={search} renderFilters={renderFilters} />
  );
};

export default withSupportOrderFilters;
